import { Component, OnInit } from '@angular/core';
import { process, State } from '@progress/kendo-data-query';
import {
  ExtUserStatut,
  SharedDataService,
  PafListsService,ExtUser, ExtUsersService, PafLabelDirective, PS_ExtUsersList_V3_Result, SimpleReponseResult
} from 'ngx-paf-common';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import {
  DataStateChangeEvent,
  GridDataResult,
  FilterService
} from "@progress/kendo-angular-grid";
import moment from 'moment';


@Component({
  selector: 'app-extusers-lists',
  templateUrl: './extusers-lists.component.html',
  styleUrls: ['./extusers-lists.component.scss']
})
export class ExtusersListsComponent implements OnInit {
  public extUsers: PS_ExtUsersList_V3_Result[] = [];
  public gridData: GridDataResult;
  public lstStatuts: ExtUserStatut[] = [];
  public state: State = {
    skip: 0,
    take: 10
  };


  private pafLabels?: PafLabelDirective;
  constructor(
    private extUsersSvc: ExtUsersService,
    private pafLstSvc: PafListsService,
    public sharedDatasSvc: SharedDataService,
    private route: ActivatedRoute
  ) {
    this.pafLabels = new PafLabelDirective(this.sharedDatasSvc, this.route);
  }

  ngOnInit(): void {
    this.reloadAll();
  }

  reloadAll(): void {
    this.sharedDatasSvc.WindowLock();
    forkJoin([
      this.pafLstSvc.getExtUserStatuts(),
      this.extUsersSvc.getExtUsersListV3()
    ])
    .subscribe({
      next:results => {
        this.lstStatuts = results[0];
        this.lstStatuts.forEach((s: ExtUserStatut, index: number) => {
          this.pafLabels.getLabel(s.LblCod).subscribe((traduction: string) => {
            (<any>s).traduction = traduction;
          });
        });
        this.lstStatuts.sortObject('traduction');
        this.extUsers = results[1];
        this.gridData = process(this.extUsers, this.state);
        this.sharedDatasSvc.WindowUnlock();
      },
      error: error=> {this.sharedDatasSvc.alert(error)}
    });

  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.extUsers, this.state);
  }

  resetPwd(user: PS_ExtUsersList_V3_Result): void {
    this.sharedDatasSvc.WindowLock();
    this.extUsersSvc.getExtUser(user.Id)
      .subscribe({
        next: (extUser: ExtUser) => {
          this.extUsersSvc.resetPassword(extUser)
            .subscribe({
              next: (res: SimpleReponseResult) => {
                if (!res.Ok) {
                  this.sharedDatasSvc.alert(res.Message);
                  return;
                }
                this.reloadAll();
                this.sharedDatasSvc.WindowUnlock();
                this.pafLabels.getLabel('Msg_mot_de_passe_reinitialise')
                  .subscribe((msg: string) => {
                    msg = msg.replace('{0}', extUser.Email);
                    this.sharedDatasSvc.informe(msg, (): void => { this.reloadAll() });
                  });
              },
              error: err => {
                this.sharedDatasSvc.alert(err.message || err, (): void => { this.reloadAll() });
              }
            });
        },
        error: err => {
          this.sharedDatasSvc.alert(err.message, (): void => { this.reloadAll() });
        }
      });
  }

  

  activateUser(user: PS_ExtUsersList_V3_Result): void {
    this.sharedDatasSvc.WindowLock();
    this.extUsersSvc.getExtUser(user.Id)
      .subscribe({
        next: (extUser: ExtUser) => {
          this.extUsersSvc.changeStatus(extUser, 1)
            .subscribe({
              next: res => {
                this.sharedDatasSvc.WindowUnlock();
                this.reloadAll();
              },
              error: err => {
                this.sharedDatasSvc.WindowUnlock();
                this.sharedDatasSvc.alert(err, (): void => { this.reloadAll() });
              }
            });
        },
        error: err => {
          this.sharedDatasSvc.WindowUnlock();
          this.sharedDatasSvc.alert(err, (): void => { this.reloadAll() });
        }
      });
  }

  lockUser(user: ExtUser): void {
    this.sharedDatasSvc.WindowLock();
    this.extUsersSvc.getExtUser(user.Id)
      .subscribe({
        next: (extUser: ExtUser) => {
          this.extUsersSvc.changeStatus(extUser, 3)
            .subscribe({
              next: res => {
                this.sharedDatasSvc.WindowUnlock();
                this.reloadAll();
              },
              error: err => {
                this.sharedDatasSvc.WindowUnlock();
                this.sharedDatasSvc.alert(err, (): void => { this.reloadAll() });
              }
            });
        },
        error: err => {
          this.sharedDatasSvc.WindowUnlock();
          this.sharedDatasSvc.alert(err, (): void => { this.reloadAll() });
        }
      });
  }


  public gridFiltersChange(values: any[], filterService: FilterService, column: any): void {
    filterService.filter({
      filters: values.map((value) => ({
        field: column.field,
        operator: "eq",
        value,
      })),
      logic: "or",
    });
  }
  displayGridArray(item: string): string {
    return item.split('|').join('<BR/>');
  }
  
  public getSupplierLink(item: PS_ExtUsersList_V3_Result):string {
    if (!(item||{}).SupplierId) return '';
    return '/supplier-details/'+item.SupplierId+'/extusers-lists';
  }

  get excelFilename():string {
    return 'Comptes externes-'+ moment().format('DD-MM-YYYY-HHmm') +'.xlsx'
  }
}
